import { Criticality, DiagnosticsMeasurementOverview, FillLevelMeasurements, Product } from '@/generated/fleetAggregationServiceTypes';
import { OverviewRow } from './OverviewRow';

type OverviewTableProps = {
    overview: DiagnosticsMeasurementOverview;
    engineOil?: FillLevelMeasurements;
    product?: Product;
};

export const OverviewTable = ({ overview, engineOil, product }: OverviewTableProps) => (
    <table className="table table-condensed">
        <tbody>
            {!overview.danger && !overview.warning && !!overview.normal && <OverviewRow criticality={Criticality.Normal} engineOil={engineOil} product={product} />}
            {!!overview.danger && <OverviewRow criticality={Criticality.Danger} count={overview.danger} engineOil={engineOil} product={product} />}
            {!!overview.warning && <OverviewRow criticality={Criticality.Warning} count={overview.warning} engineOil={engineOil} product={product} />}
            {!!overview.unknown && <OverviewRow criticality={Criticality.Unknown} count={overview.unknown} engineOil={engineOil} product={product} />}
        </tbody>
    </table>
);
